import { render, staticRenderFns } from "./MoneyLog.vue?vue&type=template&id=508cb43b&scoped=true"
import script from "./MoneyLog.vue?vue&type=script&lang=js"
export * from "./MoneyLog.vue?vue&type=script&lang=js"
import style0 from "./MoneyLog.vue?vue&type=style&index=0&id=508cb43b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508cb43b",
  null
  
)

export default component.exports